import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, Responsive, useResponsive } from '@common-fe/common-fe';

import { InvestmentsTab } from './stores/useInvestmentTab.store';
import InvestmentActivities from './InvestmentActivities';
import InvestmentsDashboard from './InvestmentsDashboard';
import InvestmentsPerformance from './InvestmentsPerformance';
import InvestmentsTopbar from './InvestmentsTopbar';
import { useInvestmentTabStore } from './stores';
interface Props {
  accountId?: string;
}
const NewInvestments: React.FC<Props> = ({ accountId }) => {
  const currentTab = useInvestmentTabStore((state) => state.currentTab);
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return (
    <Box
      direction="column"
      pad={{ bottom: isMobile ? '256px' : 'l', horizontal: isMobile ? 'spacing12' : undefined }}
    >
      <InvestmentsTopbar accountId={accountId} />
      <Responsive size={Responsive.Mobile}>
        <Box direction="row" align="center" margin={{ bottom: 'spacing8' }}>
          <Heading level={2} size="regular">
            {currentTab === InvestmentsTab.Dashboard && t('Investments')}
            {currentTab === InvestmentsTab.Performance && t('Performance')}
            {currentTab === InvestmentsTab.Activity && t('Activities')}
          </Heading>
        </Box>
      </Responsive>
      {currentTab === InvestmentsTab.Dashboard && <InvestmentsDashboard />}
      {currentTab === InvestmentsTab.Performance && <InvestmentsPerformance />}
      {currentTab === InvestmentsTab.Activity && <InvestmentActivities />}
    </Box>
  );
};

export default NewInvestments;
